<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <h5>Distribuição de Hospedagem</h5>
      </b-col>
      <b-col class="text-right">
        <b-button variant="primary" size="sm" @click="addQuarto">
          <feather-icon icon="PlusIcon" class="mr-50" />
          Novo Quarto / Alojamento
        </b-button>
      </b-col>
    </b-row>

    <!-- Grid de Quartos -->
    <b-row>
      <b-col v-for="q in quartos" :key="q.id" cols="12" md="6" lg="4">
        <b-card no-body class="border shadow-none mb-2">
          <b-card-header class="bg-light py-1 d-flex justify-content-between align-items-center">
            <h6 class="mb-0">{{ q.descricao }}</h6>
            <b-badge :variant="getOcupacaoVariant(q)">
              {{ q.ocupados }}/{{ q.capacidade }}
            </b-badge>
          </b-card-header>
          <b-card-body class="p-1">
            <small class="text-muted d-block mb-1">Camas Disponíveis:</small>
            <div class="d-flex flex-wrap">
              <div v-for="cama in q.camas" :key="cama.id" 
                   class="cama-box p-25 border rounded m-25 text-center"
                   :class="cama.ocupada ? 'bg-danger text-white' : 'bg-white text-info'"
                   v-b-tooltip.hover :title="cama.tipo">
                <feather-icon :icon="cama.tipo === 'CASAL' ? 'HeartIcon' : 'UserIcon'" size="16" />
              </div>
            </div>
            <div class="mt-2 text-right">
              <b-button variant="flat-info" size="sm" @click="gerenciarQuarto(q)">
                Distribuir Pessoas
              </b-button>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardHeader, BCardBody, BBadge, BButton, VBTooltip } from 'bootstrap-vue'

export default {
  components: { BRow, BCol, BCard, BCardHeader, BCardBody, BBadge, BButton },
  directives: { 'b-tooltip': VBTooltip },
  props: ['eventoId'],
  data() {
    return {
      quartos: [
        { id: 1, descricao: 'Quarto 101 - Ala Norte', capacidade: 3, ocupados: 1, camas: [
          { id: 1, tipo: 'SOLTEIRO', ocupada: true },
          { id: 2, tipo: 'SOLTEIRO', ocupada: false },
          { id: 3, tipo: 'SOLTEIRO', ocupada: false }
        ]},
        { id: 2, descricao: 'Suíte Master 01', capacidade: 2, ocupados: 2, camas: [
          { id: 4, tipo: 'CASAL', ocupada: true }
        ]}
      ]
    }
  },
  methods: {
    getOcupacaoVariant(q) {
      if (q.ocupados === 0) return 'success'
      if (q.ocupados < q.capacidade) return 'warning'
      return 'danger'
    },
    addQuarto() {
      // Abrir modal com seletor de "TipoQuarto" (Template)
    },
    gerenciarQuarto(q) {
      // Abrir modal de distribuição
    }
  }
}
</script>

<style scoped>
.cama-box {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
